<ngx-simplebar class="mx-n3 px-4 file-manager-content-scroll">
  @if (loadingPage) {
    <div class="mt-5">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }

  @if (!loadingPage && conversation) {
    <div class="row pt-2 profile-wrapper align-items-center">
      <div class="col-auto">
        <button (click)="goBack()" class="btn btn-sm btn-link px-0">
          <i class="ri-arrow-left-s-line align-bottom"></i> Back to Subject Files
        </button>
      </div>
      <div class="col">
        <h3 class="mb-0">{{ conversation.name }}
          <span class="text-muted fs-16 ms-2">
            ({{ assessment.subject_details.first_name }} {{ assessment.subject_details.last_name }})
          </span>
        </h3>
      </div>
      @if (conversation.status === 'WAITING' && conversation.file_type !== 'NONE' && !startedUpload && !startedRecord) {
        <div class="col-auto">
          <button type="button" (click)="chooseAction('NONE')" class="btn btn-secondary waves-effect waves-light">
            <i class="ri-arrow-left-line align-bottom"></i> Change Action
          </button>
        </div>
      }
      @if (conversation.status === 'COMPLETED' && !loadingReport) {
        <div class="col-md-auto">
          <button type="button" style="z-index: 1;" (click)="openGenerateNewReportModal()" class="btn btn-info waves-effect waves-light"><i class="ri-add-line align-bottom me-1"></i> Generate New Report</button>
        </div>
      }
    </div>
    <div>
      @switch (conversation.status) {
        @case ('WAITING') {
          <div class="row mt-3">
            @if (conversation.file_type === 'NONE') {
              <div class="col-12 text-center mb-3">
                <h1 class="display-6">Select an Action</h1>
              </div>
              <div class="col-12 col-md-4">
                <div class="card card-body text-center" style="height: 220px">
                  <div class="avatar-sm mx-auto mb-3">
                    <div class="avatar-title bg-success-subtle text-success fs-17 rounded">
                      <i class="ri-upload-line"></i>
                    </div>
                  </div>
                  <h4 class="card-title">File Upload</h4>
                  <p class="card-text text-muted">Upload a pre-recorded video file for analysis.</p>
                  <button (click)="chooseAction('UPLOAD')" class="btn btn-success mt-auto">Select</button>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="card card-body text-center" style="height: 220px">
                  <div class="avatar-sm mx-auto mb-3">
                    <div class="avatar-title bg-success-subtle text-success fs-17 rounded">
                      <i class="ri-vidicon-2-line"></i>
                    </div>
                  </div>
                  <h4 class="card-title">Record Session</h4>
                  <p class="card-text text-muted">Record the conversation and upload automatically.</p>
                  <button (click)="chooseAction('RECORD')" class="btn btn-success mt-auto">Select</button>
                </div>
              </div>
              <div class="col-12 col-md-4">
                <div class="card card-body text-center" style="height: 220px">
                  <div class="avatar-sm mx-auto mb-3"><div class="avatar-title bg-light text-muted fs-17 rounded"><i class="ri-live-line"></i></div></div>
                  <h4 class="card-title">Live Analysis (Coming Soon)</h4>
                  <p class="card-text text-muted">Get real-time analysis results during a live recording.</p>
                  <button class="btn btn-secondary mt-auto" disabled>Select</button>
                </div>
              </div>
            }
            @if (conversation.file_type === 'UPLOAD') {
              <app-upload-activity-video [projectId]="projectId" [caseId]="assessmentId" [activityId]="activityId" (startedUploading)="onUploadStart($event)" (uploadComplete)="onUploadComplete()"></app-upload-activity-video>
            }
            @if (conversation.file_type === 'RECORD') {
              <app-record-activity-session [projectId]="projectId" [caseId]="assessmentId" [activityId]="activityId" (startedRecording)="onRecordStart($event)" (uploadComplete)="onUploadComplete()"></app-record-activity-session>
            }
          </div>
        }
        @case ('ANALYZING') {
          <div>
            <div class="card card-body">
              <div class="text-center p-5">
                <lord-icon src="https://cdn.lordicon.com/euaablbm.json" trigger="loop" colors="primary:#3080e8,secondary:#b4b4b4" style="width:120px;height:120px"></lord-icon>
                <h4 class="mb-3 mt-4">Analysis in Progress</h4>
                <p class="text-muted mx-4 mb-0">The system is processing and analyzing the recorded video. This may take a few minutes depending on the video length.</p>
              </div>
            </div>
          </div>
        }
        @case ('STARTED') {
          <div>
            <div class="card card-body">
              <div class="text-center p-5">
                <lord-icon src="https://cdn.lordicon.com/ynooheet.json" trigger="loop" colors="primary:#0ab39c,secondary:#0ab39c" style="width:120px;height:120px"></lord-icon>
                <h4 class="mb-3 mt-4">Session in Progress</h4>
                <p class="text-muted mx-4 mb-0">This conversation session is currently being recorded and is visible to other authorized users.</p>
              </div>
            </div>
          </div>
        }
        @case ('FAILED') {
          <div>
            <div class="card card-body">
              <div class="text-center p-5">
                <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
                <h4 class="mb-3 mt-4">Analysis Failed</h4>
                <p class="text-muted mx-4 mb-0">Something went wrong during the analysis. You may need to delete this activity and try again.</p>
              </div>
            </div>
          </div>
        }
        <!-- STATE: COMPLETED -->
        @case ('COMPLETED') {
          <div>
            <!-- Show progress bar while loading the big report -->
            @if (loadingReport) {
              <div class="text-center mt-5 pt-4 mb-4">
                <h4 class="mb-3">Loading Report Data...</h4>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="progress animated-progress custom-progress progress-label p-0 w-50">
                    <div class="progress-bar bg-primary" role="progressbar" [style.width.%]="progress" [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100">
                      <div class="label">{{ progress }}%</div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <!-- Show the report component *only* when the report data is fully loaded -->
            @if (!loadingReport && conversationData) {
              <app-conversation-data [page_source]="'case'" [page_data]="page_data" [conversation]="conversation" [targetReportId]="targetReportId" (reportOpened)="targetReportId = null" [conversation_data]="conversationData" [allowSpecial]="allowSpecial" (updateReportsEvent)="handleUpdateReports($event)"></app-conversation-data>
            }
          </div>
        }
      }
    </div>
  }

</ngx-simplebar>


<app-generate-new-report #generateNewReport [page_source]="'case'" [page_data]="page_data" (updateReportsEvent)="handleUpdateReports($event)"></app-generate-new-report>